<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p.u-mb-ts {{item.desc}}
        AppLink(v-if="item.url" :to="item.url" :title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}


  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-12
          .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
            h4 {{item.title}}
            AppLink(v-if="item.url" :to="item.url" :title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}

  .u-mb-md


</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Illustration",
    "pageDesc":"We create custom illustration with different styles for websites, animation movies, posters, social media, prints and more.",
    "mantra":"Telling stories with |custom illustrations.",
    "sec1Items":{
      "1":{
        "title":"Posters",
        "desc":"New campaign? Or maybe some branded posters for your online presence on social media. Whatever your poster replacement, we can custom illustration for it.",
        "url":"/services/advertising"
      },
      "2":{
        "title":"Packaging",
        "desc":"Steal the eyes on the shelves with custom packaging illustration that ranges from toys to food and beauty products.",
        "url":"/solutions/packaging"
      },
      "3":{
        "title":"Website",
        "desc":"Adding a touch of brandability to your ecommerce store banners or creating hero illustration headers for your Saas solution.",
        "url":"/services/web-design"
      },
      "4":{
        "title":"Infographics",
        "desc":"Consolidating your big ideas into visually appealing and easily understandable pieces of illustration to be placed on your blog or other marketing channels."
      }
    },
    "sec2":"Creating visuals that evoke emotions.",
    "sec2Items":{
      "1":{
        "title":"You tell us a story",
        "desc":"We start with a story. You tell us more about your business, target audience, why you need the illustration, where are you going to place them and how your current brand looks like. "
      },
      "2":{
        "title":"We do the sketches",
        "desc":"We try different art styles and schools. From relatsic to scartsic and serialism and audit the results of every route together."
      },
      "3":{
        "title":"Then move to the digital",
        "desc":"After agreeing on the overall style we go digital! We form the mood by selecting the colors and the surrounding environment. Then we add more visual details to tell better stories."
      },
      "4":{
        "title":"And we are ready to go",
        "desc":"We deliver the illustration done in the format and sizes needed to be ready for going into the real world."
      }
    },
    "sec3":"Custom illustrations that speaks of your business.",
    "sec3Items":{
      "1":{
        "title":"We do custom illustrations as part of the brand identity design efforts to make your brand standout from the hassle.",
        "url":"/services/brand-identity-design"
      },
      "2":{
        "title":"Whether complex, lined or glyph, we illustrate icons that matches your brand and website style.",
        "url":"/solutions/illustrations"
      }
    }
  },
  "ar": {
    "pageTitle":"تصميم الاليستريشن",
    "pageDesc":"يمكنك إنشاء رسوم الاليستريشن باستخدام أساليب مختلفة من أجل المواقع وأفلام الأنيميشن والبوسترات ووسائل التواصل الإجتماعي.",
    "mantra":"اسرد قصصك من خلال |تصميم الاليستريشن.",
    "sec1Items":{
      "1":{
        "title":"البوسترات",
        "desc":"هل تؤسس حملة جديدة؟ أو ربما تحتاج لبعض البوسترات المناسبة لهويتك التجارية من أجل وسائل التواصل الإجتماعى. أيًا كان غرضك سنساعدك في الحصول على رسوم الإليستريشن المناسبة لك. ",
        "url":"/services/advertising"
      },
      "2":{
        "title":"التغليف",
        "desc":"طف عيون عملائك من اللحظة الأولى من خلال رسوم الاليستريشن التي تساعدك على إضفاء لمسة جمالية في تعبئة وتغليف منتجاتك. ",
        "url":"/solutions/packaging"
      },
      "3":{
        "title":"رسومات الموقع",
        "desc":"امنح موقعك لمسة مختلفة تتناسب مع هويتك التجارية من خلال بنرات متجر التجارة الإلكترونية أو إنشاء رسوم  توضيحية من أجل لحلول Saas.",
        "url":"/services/web-design"
      },
      "4":{
        "title":"الإنفوجرافيك",
        "desc":"بسط الأفكار والمعلومات التي لديك من خلال رسومات توضيحية جذابة وسهلة الفهم يمكن استخدامها في مدونتك أو حتى عبر قنوات وسائل التواصل الإجتماعي المختلفة."
      }
    },
    "sec2":"عبر عن أفكارك برسومات مفعمة بالحياة.",
    "sec2Items":{
      "1":{
        "title":"القصة",
        "desc":"نبدأ من خلال قصة. نستمع إلى قصة عملك والجمهور المستهدف ولماذا تحتاج إلى الاليستريشن وأين ستستخدمهم، وندرس هويتك التجارية جيدًّا لمعرفة الأسلوب الذي يتماشى معها."
      },
      "2":{
        "title":"رسومات الاسكتش",
        "desc":"نجرب  أساليب الفن والمدارس المختلفة لنعرف من منها المناسب لهويتك. من الواقعية إلى الهزلية والسريالية ثم نراجع كل ما قمنا به لاختيار الأفضل."
      },
      "3":{
        "title":"الرسوم الرقمية",
        "desc":"بعد الاتفاق على الأسلوب العام نتجه للرسوم الرقمية، نشكل المزاج العام عن طريق اختيار الألوان والبيئة المحيطة. ثم نضيف المزيد من التفاصيل لنروي قصصًا أفضل."
      },
      "4":{
        "title":"الرسوم النهائية",
        "desc":"نقدم رسوم الاليستريشن الذي تم إنجازه بالشكل والحجم المطلوب لتكون جاهزة لعرضها في مكانها المخصص."
      }
    },
    "sec3":"رسوم الاليستريشن التي تتحدث عن عملك.",
    "sec3Items":{
      "1":{
        "title":"نقوم بعمل رسوم الاليستريشن مخصصة كجزء من جهود تصميم الهوية التجارية لجعل علامتك بارزة عن غيرها من العلامات.",
        "url":"/services/brand-identity-design"
      },
      "2":{
        "title":"سواء كانت معقدة أوخطية أو صور، فإننا نرسم الأيقونات التي تتطابق مع علامتك التجارية وأسلوب موقعك.",
        "url":"/solutions/illustrations"
      }
    }
  }
}
</i18n>
